import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LegalHub from "@/components/LegalHub";
import { COOKIE_SETTINGS_EVENT, readCookieConsent, saveCookieConsent } from "@/lib/cookieConsent";

const CookieNotice = () => {
  const [visible, setVisible] = useState(false);
  const [legalOpen, setLegalOpen] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    try {
      if (readCookieConsent()) return;
    } catch {
      /* ignore */
    }
    const t = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const openSettings = () => setVisible(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, openSettings);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, openSettings);
  }, []);

  /* Сообщаем ScrollToTop о своём присутствии и высоте, чтобы стрелка не наезжала на плашку. */
  useEffect(() => {
    const emit = () => {
      window.dispatchEvent(
        new CustomEvent("wmt:cookie-notice", {
          detail: { visible, height: cardRef.current?.offsetHeight ?? 0 },
        }),
      );
    };
    const raf = requestAnimationFrame(emit);
    window.addEventListener("resize", emit);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", emit);
    };
  }, [visible]);

  const choose = (value: "analytics" | "necessary") => {
    saveCookieConsent(value);
    setVisible(false);
  };

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 16 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="fixed bottom-4 left-4 right-4 z-40 sm:left-auto sm:right-4 sm:max-w-md"
          >
            <div ref={cardRef} className="rounded-lg border border-border bg-card/95 px-4 py-4 shadow-[0_4px_24px_-8px_rgba(0,0,0,0.15)] backdrop-blur-md">
              <p className="text-xs leading-relaxed text-muted-foreground">
                Сайт использует необходимые cookie. Яндекс Метрика и Webvisor включаются только с вашего согласия.{" "}
                <button
                  type="button"
                  onClick={() => setLegalOpen(true)}
                  className="underline underline-offset-2 hover:text-foreground transition-colors"
                >
                  Подробнее
                </button>
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <button type="button" onClick={() => choose("analytics")} className="h-9 rounded-full bg-accent px-4 font-heading text-xs text-accent-foreground transition-colors hover:bg-accent/90">Разрешить аналитику</button>
                <button type="button" onClick={() => choose("necessary")} className="h-9 rounded-full border border-border px-4 font-heading text-xs text-foreground transition-colors hover:bg-muted">Только необходимые</button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <LegalHub open={legalOpen} onOpenChange={setLegalOpen} defaultSection="cookies" />
    </>
  );
};

export default CookieNotice;
